<p-iconField>
  <p-inputIcon styleClass="fas fa-folder"></p-inputIcon>
  <p-multiSelect
    *ngIf="tagStore.products() as tags"
    class="w-20rem"
    [placeholder]="label"
    (ngModelChange)="onTagsChange()"
    [options]="tags"
    [(ngModel)]="selectedProducts"
    optionLabel="title"
    optionValue="_id"
    dataKey="_id">
    <ng-template let-item pTemplate="item">
      <div class="flex align-items-center gap-2">
        <i class="fas fa-folder"></i>
        <div>{{ item.title }}</div>
      </div>
    </ng-template>
  </p-multiSelect>
</p-iconField>
